<ng-container>
  <span class="course-list-header__title">{{ title }}</span>
  @if (subTitle) {
    <div class="course-list-header__subtitle">{{ subTitle }}</div>
  }
</ng-container>
